<template>
  <div class="product-album-swiper-wrapper">
    <ClientOnly>
      <Suspense>
        <!-- 相片列表 -->
        <AlbumSwiper class="product-slide" :images="props.images" :hide-right-side="props.isMobile" />
        <template #fallback>
          <ProductAlbumSwiperSkeleton />
        </template>
      </Suspense>
      <template #fallback>
        <ProductAlbumSwiperSkeleton />
      </template>
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import ProductAlbumSwiperSkeleton from '@/components/page/products/ProductAlbumSwiperSkeleton.vue'

interface Props {
  images: string[]
  isMobile: boolean
}

const AlbumSwiper = defineAsyncComponent(() => import('@/components/slide/album-swiper.vue'))

const props = defineProps<Props>()
</script>

<style lang="scss" scoped>
.product-album-swiper-wrapper {
  --album-swiper-height-mobile: 375px;
  --album-swiper-height-desktop: 524px;
}
</style>
